// Function for sleeping

export function sleep(milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }